export const boardTopMenuTour = {
  key: "boardTopMenu",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-topmenu-info"]',
      content: t("Tour_BoardTopMenu_Info"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-topmenu-chat"]',
      content: t("Tour_BoardTopMenu_Chat"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-topmenu-meeting"]',
      content: t("Tour_BoardTopMenu_Meeting"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-topmenu-call"]',
      content: t("Tour_BoardTopMenu_Call"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-topmenu-sharedscreen"]',
      content: t("Tour_BoardTopMenu_SharedScreen"),
      placement: "bottom",
    },
  ],
};
